import { func_file } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {
    const {
        allPosCountReport
    } = useCustomSelector("reporting");

    function exportData() {
        // Set Header Names
        let headers = [
            [   
                "Site ID",
                "Location ID",
                "Location",
                "Total Sales Transaction"
            ]
        ];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = allPosCountReport.map((rowDetail) => {
            return [
                (rowDetail?.SiteID? rowDetail.SiteID: ""),
                (rowDetail?.SiteID? rowDetail.LocationID: ""),
                (rowDetail?.SiteID? rowDetail.LocationName: ""),
                (rowDetail?.SiteID? rowDetail.TotalSalesTransaction: ""),
            ]
        });

        func_file.generateFile_XLSX("POS Count Report", "POS Count", headers, rows, null, null, columnWidths);
    }

    return exportData;
}